module.exports = __webpack_public_path__ + "img/T1_ty_1.adc34fb4.png";